var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconRevert = function SvgS2IconRevert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currrentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 13.95H2.7a.675.675 0 0 1 0-1.35h13.5a.675.675 0 0 1 0 1.35ZM9.9 2.925c-3.399 0-6.234 2.534-6.848 5.875L2.28 7.504a.675.675 0 0 0-1.159.692l1.616 2.71a.675.675 0 0 0 .941.225l2.628-1.668a.675.675 0 0 0-.724-1.14l-1.209.768C4.853 6.356 7.146 4.275 9.9 4.275c3.102 0 5.625 2.638 5.625 5.88a.675.675 0 0 0 1.35 0c0-3.987-3.129-7.23-6.975-7.23Z"
  })));
};
export default SvgS2IconRevert;